const rot13 = (s) => {
  return s.replace( /[A-Za-z]/g , function(c) {
    return String.fromCharCode( c.charCodeAt(0) + ( c.toUpperCase() <= "M" ? 13 : -13 ) )
  })
}

document.addEventListener('DOMContentLoaded', event => {
  function is_touch_device() {
    return !!('ontouchstart' in window);
  }
  if (is_touch_device()) {
    document.body.classList.add('touch-enabled')
  }

  if (!!window.MSInputMethodContext && !!document.documentMode) {
      document.body.classList.add('ie-11')
  }

  var _win = $(window)
  var $page_header = $('.page-header-sticky')
  var _scrollPos = 0
  if ($page_header.length > 0) {
    $('*').waypoint({
      handler: function(direction) {
        var _toggle = (direction == "up" && _win.scrollTop() > 100)
        $page_header.toggleClass('sticky', _toggle)
      }
    })
  }

  $('.header-logo').each(function() {
    var $page = $('.page');
    var $logo = $(this);
    $('*').waypoint({
      handler: function(direction) {
        var top = $page.offset().top;
        var _toggle = _win.scrollTop() > top;
        $logo.toggleClass('sticky', _toggle);
      }
    })
  });

  $('.btn-menu').on('click', function(e) {
    _scrollPos = _win.scrollTop()
    _win.scrollTop(0)
    setTimeout(function(){_win.scrollTop(0)}, 200)
  })

  $('.burger-close').on('click', function() {
    setTimeout(function(){_win.scrollTop(_scrollPos)}, 200)
  })


  const slideshow = document.querySelectorAll('.slideshow-rounded')
  if (slideshow.length) {
    $('.slideshow-rounded .slide-container').slick({
      accessibility: false,
      arrows: false,
      centerMode: true,
      edgeFriction: 0.15,
      focusOnSelect: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 500,
          settings: 'unslick'
        }
      ],
      slidesToShow: 1,
      variableWidth: true
    });
  }

  var slider = document.getElementById("hero_slideshow")
  if (slider !== null) {
    var slides = slider.children,
      slideIndex = 0,
      slideDuration = 6000;
    function slideShow() {
      function fadeIn(e) { e.classList.add("fadeIn") }
      function fadeOut(e) { e.classList.remove("fadeIn") }
      fadeOut(slides[slideIndex])
      slideIndex++
      if (slideIndex == slides.length) slideIndex = 0
      fadeIn(slides[slideIndex])
      setTimeout(function () { slideShow() }, slideDuration)
    }
    setTimeout(function(){slideShow()}, slideDuration)
  }

  // news

  var $masonryList = $('.masonry')
  if ($masonryList.length > 0) {
      var $masonryGrid = $masonryList.masonry({
        "itemSelector": ".masonry-item",
        "gutter": 20
      });
      // layout Masonry after each image loads
      $masonryGrid.imagesLoaded().progress( function() {
        $masonryGrid.masonry('layout');
      });

      var infinite = new Waypoint.Infinite({
        element: $('.masonry')[0],
        items: '.masonry-item',
        onAfterPageLoad: function(itms) {
          $masonryGrid.masonry( 'appended', itms );
          $masonryGrid.imagesLoaded().progress( function() {
            $masonryGrid.masonry( 'layout' )
          });
        }
      });
  }

  // contact list email obfuscation
  let _emails = document.getElementsByClassName('obfuscated')
  var _subject = ""
  for (var i = _emails.length - 1; i >= 0; i--) {
    _subject = _emails[i].dataset.subject || ""
    _emails[i].href = 'mailto:' + rot13(_emails[i].dataset.email) + _subject
  }

  const cmsforms = document.querySelectorAll('form.csrf-req-form')
  if (cmsforms.length) {
    const csrftoken = Cookies.get('csrftoken')
    if (csrftoken === undefined) {
      $.get('/_cmsforms/token/')
    }
  }

  function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method))
  }
  function beforeSend(xhr, settings) {
    const csrftoken = Cookies.get('csrftoken')
    if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
      xhr.setRequestHeader("X-CSRFToken", csrftoken)
    }
  }

  for (var i=0; i < cmsforms.length; i++) {
    let form = cmsforms[i]
    form.addEventListener('submit', event =>  {
      if ($(form).hasClass('no-ajax')) {
        $(form).append('<input type="hidden" name="csrfmiddlewaretoken" value="' + Cookies.get('csrftoken') +'">')
        return
      }
      event.preventDefault();
      const form_data = new FormData(form)
      $.ajax({
        url: form.getAttribute('action'),
        type: "POST",
        data: $(form).serialize(),
        beforeSend: beforeSend,
        success: (data, status) => {
          $(form).addClass('success').removeClass('error')
          $(form).html(data.success_message)
          $("html,body").animate({"scrollTop": $(form).offset().top - 100}, 300)
        },
        error: (data, status) => {
          $(form).addClass('error')
          $("html,body").animate({"scrollTop": $(form).offset().top - 20}, 300)
        }
      })
    })
  }

  $('.js-mailchimp-form').on('submit', function (e) {
    var $form = $(this);
    var url = $form.attr('action');
    $.ajax({
      url: url,
      type: 'post',
      data: $form.serialize(),
      success: function (data) {
        var message;
        var selectors = [
          '.js-mailchimp-form-non-field-errors-wrapper',
          '.js-mailchimp-form-email-errors-wrapper',
          '.js-mailchimp-form-privacy-ok-errors-wrapper',
        ];
        if (data === 'OK') {
          $('.js-mailchimp-form-success').slideDown();
          $form.slideUp();
        }
        else if (data = 'Registered') {
          message = $form.attr('data-registered-message');
          $('.js-mailchimp-form-non-field-errors-wrapper').html(
            '<ul class="errorlist"><li>' + message + '</li></ul>'
          );
        }
        else if (data = 'Not OK') {
          message = $form.attr('data-error-message');
          $('.js-mailchimp-form-non-field-errors-wrapper').html(
            '<ul class="errorlist"><li>' + message + '</li></ul>'
          );
        } else {
          $.each(selectors, function (index, selector) {
            var html = $(data).find(selector).html();
            $form.find(selector).html(html);
          });
        }
      },
    });
    e.preventDefault();
  });

  var gdpr_ok = typeof(Cookies.get('gdpr_ok')) !== 'undefined';
  var no_newsletter = typeof(Cookies.get('no_newsletter')) !== 'undefined';

  if (!gdpr_ok) {
    $('.js-privacy-overlay').show();
  }
  if (!no_newsletter) {
    $('.js-newsletter-overlay').show();
  }
  if (!gdpr_ok && !no_newsletter) {
    $('.js-overlay').addClass('overlay--double');
  }

  $('.js-newsletter-overlay__close').click(function (e) {
    $('.js-newsletter-overlay').fadeOut();
    Cookies.set('no_newsletter', 1);
    e.preventDefault();
  });

  $('.js-legal-text__close').click(function(e) {
    $(this).parents('.js-legal-text').slideUp();
    e.preventDefault();
  });

  $('.js-language-menu__opener').click(function (e) {
    $('.js-language-menu__dropdown').toggleClass('open');
    e.preventDefault();
  });

  $('.js-gdpr-checkbox').change(function () {
    if ($(this).is(':checked')) {
      Cookies.set('gdpr_ok', 1);
      $('.js-privacy-overlay').fadeOut();
    }
  });
});

document.addEventListener('DOMContentLoaded', event => {
  /**
   * Align elements in adjacent text-image plugins.
   */
  var grids = [];
  $('.flexible-plugin--grid-plugin').each(function () {
    var $text_images = $(this).find('.flexible-plugin--text-image');
    if ($text_images.length > 1) {
      var grid = {
        'titles': $(this).find('.flexible-plugin__words-title'),
        'images': $(this).find('.flexible-plugin__image')
      };
      if ($(this).find('.flexible-plugin__grid--halfs').length > 0) {
        grid.cols = 2;
      } else {
        grid.cols = 3;
      }
      grids.push(grid);
    }
  });

  function get_max_height($elements) {
    var max_height = 0;
    $elements.each(function () {
      max_height = Math.max(max_height, $(this).height());
    });
    return max_height;
  }

  function adjust_height() {
    var i, title_height, image_height;
    for (i = 0; i < grids.length; i++) {
      grids[i].titles.css({height: 'auto'});
      grids[i].images.css({height: 'auto'});
      title_height = get_max_height(grids[i].titles);
      image_height = get_max_height(grids[i].images);
      if (
          (grids[i].cols === 2 && $(window).width() >= 425)
          ||
          (grids[i].cols === 3 && $(window).width() >= 680)
      ) {
        grids[i].images.css({height: image_height + 'px'});
        grids[i].titles.css({height: title_height + 'px'});
      }
    }
  }

  adjust_height(grids);
  $('body').imagesLoaded().progress(function () {
    adjust_height(grids);
  });
  $(window).resize(function () {
    adjust_height(grids);
  });
  
  /** Product Slider **/
  var $slider = $('.element-list');
  var $slides = $slider.find('> .plugin, > .icon-element');
  $slider.slick({
    arrows: false,
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      },
      {
        breakpoint: 767,
        slidesToShow: 1,
      }
    ]
  }).slick('slickFilter', '.product, .icon-element');  /* workaround: https://stackoverflow.com/a/30037412/1378264 */
    /** The end **/

});


document.addEventListener('DOMContentLoaded', () => {
  (() => {
          const modal = document.querySelector(".popup");
          modal.style.display = "flex";
      const hide_banner = () => {
          $('.js-cookie-banner').hide();
          $('.js-cookie-banner-overlay').hide();
      }



       let all =  document.querySelector('#Alle');
       let saveBtn = document.querySelector('.popup .cookie__link');
       all.addEventListener('click', () =>{
         if ( all.checked == true ) {    
          saveBtn.classList.remove("cookie__link--allow-necessary","js-cookie__link--allow-necessary");
          saveBtn.classList.add("js-cookie-banner__agree-all");
         } else {
           if ( all.checked == false ){
            saveBtn.classList.add("cookie__link--allow-necessary","js-cookie__link--allow-necessary");
            saveBtn.classList.remove("js-cookie-banner__agree-all");
           }
         }
      });

 
  
      const show_foreign_content = () => {
          $('[data-foreign-content]').each(function () {
              if (Cookies.get('allow-cookies') === 'all') {
                  const content = $(this).attr('data-foreign-content');
                  $(this).replaceWith(content);
              }
              else {
                  const content = $('body > .js-blocked-template').html();
                  $(this).html(content);
              }
          });
      }
  
      show_foreign_content();
  
      if (Cookies.get('allow-cookies')) {
          hide_banner();
      }
  
      $('body').on('click', '.js-cookie-banner__agree-all', function (event) {
          Cookies.set('allow-cookies', 'all', { expires: 100 });
          hide_banner();
          show_foreign_content();
          event.preventDefault();
      });
  
      $('.js-cookie__link--allow-necessary').click(function (event) {
          Cookies.set('allow-cookies', 'necessary', { expires: 20 });
          hide_banner();
          event.preventDefault();
      });
  })();
})






//////////////////
// WEBPACK FOOTER
// ./web/project/static_src/es6/app.js
// module id = 0
// module chunks = 0